import type { App, Plugin } from 'vue'
import type { Router } from 'vue-router'
import { initTourEngine, maybeAutoStart } from './engine/useTourEngine'
import { buildTourContext } from './composables/useTourContext'

/**
 * Self-contained tour plugin. Registers its OWN router.afterEach (mirroring
 * RouteProgressBar) so the engine can auto-start a screen's tour on first visit
 * without polluting router/index.ts. One line in main.ts wires it up.
 */
export function createTourPlugin(router: Router): Plugin {
  return {
    install(_app: App) {
      initTourEngine(router, buildTourContext)
      router.afterEach((to) => {
        // Wait a frame so the destination screen's DOM mounts before we try to
        // resolve step targets / auto-start.
        requestAnimationFrame(() => maybeAutoStart(to.name as string | undefined))
      })
    },
  }
}
